import React, { useMemo } from 'react'
import MetadataModal from './MetadataModal.jsx'
import { deleteAsset, restoreAsset } from '../../../assets/requests'
import { toast } from 'react-toastify'
import leftArrow from '../../../assets/images/lft-arrow.png'
import cancelBtn from '../../../assets/images/cancel.png'
import deleteImg from '../../../assets/images/delete2.svg'
import emptyHeart from '../../../assets/images/empty-heart.svg'
import filledHeart from '../../../assets/images/full-heart.svg'
import { useFavoriteToggle } from '../hooks/useFavoriteToggle'
import { useTVRemoteControl } from '../hooks/useTVRemoteControl'
import '../../../assets/stylesheets/modal.css'

export const ModalHtml = props => {
  // TV Remote Control hook for modal navigation
  useTVRemoteControl({
    onModalArrowLeft: () => handleModalArrowClick(props, 'left'),
    onModalArrowRight: () => handleModalArrowClick(props, 'right'),
    isModalActive: props.state.modalActive,
    enableGalleryNavigation: false,
    enableModalNavigation: true,
    enableAssetScrolling: false,
    loadTVStyles: false
  })

  const handleOverlayClick = e => {
    if (e.target === e.currentTarget) {
      props.onClose()
    }
  }

  return (
    <div
      className={`modal ${props?.state.modalActive ? 'active' : ''}`}
      onClick={handleOverlayClick}
    >
      <ModalInnerHtml {...props} onClose={props.onClose} props={props} />
    </div>
  )
}

const ModalInnerHtml = ({ state, dispatch, onClose, props }) => {
  const currentAssetId = state.currentAsset || state.modalData?.assetId
  const publishedAssets = useMemo(
    () => props?.state?.publishedAssets || state.publishedAssets,
    [props?.state?.publishedAssets, state.publishedAssets]
  )

  const { isFavorited, toggleFavorite: handleToggleFavorite } = useFavoriteToggle({
    assetId: currentAssetId,
    publishedAssets,
    assetsArray: Array.isArray(state.assets) ? state.assets : null,
    dispatchUpdate: props?.dispatch || dispatch
  })

  const handleDeleteAsset = async () => {
    let assetId = state.currentAsset

    if (!assetId) {
      assetId =
        state.modalData?.assetId || Object.keys(props.state.publishedAssets || {})[0]
    }

    if (!assetId) {
      toast.error('Unable to delete asset - missing asset ID', {
        autoClose: 2000,
        hideProgressBar: true
      })
      return
    }

    const userId = localStorage.getItem('username')

    try {
      await deleteAsset({
        userId: userId,
        assetId: assetId
      })

      // Capture asset data before removing so we can restore on undo
      const deletedAssetData = props.state.publishedAssets?.[assetId] || null

      // Remove asset from all asset stores (raw, signed, published)
      if (props.dispatch) {
        props.dispatch({ type: 'remove_asset', payload: assetId })
      }

      if (props.onAssetDeleted) {
        props.onAssetDeleted(assetId)
      }

      onClose()

      const handleUndo = async () => {
        try {
          await restoreAsset({ userId, assetId })
          // Re-add asset to state instead of reloading page
          if (props.dispatch && deletedAssetData) {
            props.dispatch({
              type: 'append_published_assets',
              payload: { [assetId]: deletedAssetData }
            })
          }
          toast.success('Photo restored!', {
            autoClose: 1000,
            hideProgressBar: true
          })
        } catch (err) {
          console.error('Failed to restore asset:', err)
          toast.error('Failed to restore photo.', {
            autoClose: 2000,
            hideProgressBar: true
          })
        }
      }

      toast.info(
        ({ closeToast }) => (
          <div>
            Photo deleted.{' '}
            <button
              onClick={() => { handleUndo(); closeToast(); }}
              style={{
                background: 'none',
                border: 'none',
                color: '#3498db',
                cursor: 'pointer',
                textDecoration: 'underline',
                fontSize: 'inherit',
                padding: 0
              }}
            >
              Undo
            </button>
          </div>
        ),
        { autoClose: 5000, hideProgressBar: false }
      )
    } catch (error) {
      console.error('Failed to delete asset: ', error)
      toast.error('Failed to delete asset.', {
        autoClose: 2000,
        hideProgressBar: true
      })
    }
  }

  return (
    <>
      <div className="close-modal-container">
        {state.modalStatus !== 'MetaData' && (
          <div
            className={`back-arrow-container ${
              state.modalStatus !== 'Image' ? 'active' : ''
            }`}
          >
            <img
              alt="Back to asset"
              src={leftArrow}
              className="back-modal-icon"
              onClick={() =>
                handleModalStatusChange({ state, dispatch }, 'Image')
              }
            ></img>
          </div>
        )}
        <img
          src={cancelBtn}
          className="close-modal-icon"
          alt=""
          onClick={e => handleModalClose(props, e)}
        />
      </div>
      <div className="modal-title">
        {/* Title can be added here if needed */}
      </div>
      <div className="modal-center">
        <div className="modal-content01">
          {/* {state.modalStatus === 'Tags' && <TagsContainer state={state} dispatch={dispatch} />} */}
          {state.modalStatus === 'MetaData' && (
            <MetadataModal state={state} dispatch={dispatch} />
          )}
          {state.modalStatus === 'Image' &&
            modalImageHtml({
              state,
              dispatch,
              handleToggleFavorite,
              handleDeleteAsset,
              isFavorited
            })}
        </div>
      </div>
      <div className="modal-button-container01">
        {/* Additional buttons or content can be added here if needed */}
      </div>
    </>
  )
}

const modalImageHtml = props => {
  let imageUrl
  console.log('Image URL:', props.state)
  if (props.state.modalData?.asset) {
    const { fileUrl = '' } = props.state.modalData.asset
    imageUrl = fileUrl || ''
  } else {
    const cur = props.state.currentAsset || props.state.modalData?.assetId

    const asset = props.state.assets.find(a => a.id === cur)
    imageUrl = asset?.fileUrl || ''
  }

  return (
    <div className="modal-title-image">
      <div className="modal-body">
        <div className="modal-main-window">
          {/* Main Image */}
          <img className="modal-main-image fluid-image" alt="" src={imageUrl} />
          <div className="modal-icon-row">
            <div className="modal-icon-container">
              <div className="left-side-modal-buttons">
                <div className="modal-button-container">
                  <button
                    onClick={() => props.handleToggleFavorite()}
                    className="button-med favorite-button"
                  >
                    <img
                      src={props.isFavorited ? filledHeart : emptyHeart}
                      alt={props.isFavorited ? 'Unfavorite' : 'Make favorite'}
                      className="fav-img-btn"
                    />
                  </button>
                  <button
                    className="button-med delete-button"
                    onClick={() => props.handleDeleteAsset()}
                  >
                    <img
                      src={deleteImg}
                      alt="Delete"
                      className="delete-img-btn"
                    />
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export function handleModalOpen(props) {
  //console.log('handleModalOpen called with props:', props);
  let assetToBeDisplayed
  if ('assetId' in props.payload) {
    const assetId = props.payload.assetId
    //console.log('Attempting to find asset with ID:', assetId);
    assetToBeDisplayed = props.state.publishedAssets.find(
      asset => asset.id === assetId
    )
  } else if ('assetIdx' in props.payload) {
    const assetIdx = props.payload.assetIdx
    //console.log('Attempting to find asset with Index:', assetIdx);
    assetToBeDisplayed = props.state.publishedAssets[assetIdx]
  }

  if (assetToBeDisplayed) {
    props.dispatch({
      type: 'set_modal_data',
      payload: {
        asset: assetToBeDisplayed,
        assetId: assetToBeDisplayed.id
      }
    })
    props.dispatch({ type: 'set_modal_active', payload: true })
  } else {
    console.error('Asset not found.')
  }
}

const handleModalStatusChange = (props, status) => {
  props.dispatch({ type: 'set_modal_status', payload: status })
  //setModalStatus(status);
}

function handleModalClose(props, e) {
  console.log('props to close modal', props)
  if (
    e.target.classList.contains('modal') ||
    e.target.classList.contains('close-modal-icon')
  ) {
    props?.dispatch({ type: 'set_modal_active', payload: false })
    props?.dispatch({ type: 'set_modal_status', payload: 'Image' })

    if (typeof props.onClose === 'function') {
      props.onClose()
    } else {
      console.error('onClose is not available or not a function', props)
    }
  }
}

function getAssetDate(asset) {
  return new Date(asset?.metadata?.content?.date ?? asset?.content?.date ?? 0)
}

function getSortedAssets(assets) {
  return Object.values(assets).sort((a, b) => getAssetDate(a) - getAssetDate(b))
}

function handleModalArrowClick(props, direction) {
  const sortedAssets = getSortedAssets(props.state.publishedAssets)
  if (!sortedAssets.length) return
  const currentAssetId =
    props.state?.modalData?.assetId ?? props.state?.currentAsset
  if (!currentAssetId) return
  const currentIdx = sortedAssets.findIndex(a => a.id === currentAssetId)
  if (currentIdx === -1) return
  let newIndex = currentIdx
  if (direction === 'left') {
    newIndex = currentIdx > 0 ? currentIdx - 1 : sortedAssets.length - 1
  } else if (direction === 'right') {
    newIndex = currentIdx < sortedAssets.length - 1 ? currentIdx + 1 : 0
  }

  const newAsset = sortedAssets[newIndex]
  props.dispatch({
    type: 'set_modal_data',
    payload: { asset: newAsset, assetId: newAsset.id }
  })
}
